import { Badge, BlockStack, Card, Text } from '@shopify/polaris'
import type { HealthReport } from '../../../../sdk/health.api'

const LEVEL_COLOR = {
  ready:           { bg: '#e3f1df', text: '#108043' },
  needs_attention: { bg: '#fdf3d0', text: '#916a00' },
  critical:        { bg: '#fdf0f0', text: '#bf0711' },
}

const LEVEL_LABEL = {
  ready:           'Ready',
  needs_attention: 'Needs Attention',
  critical:        'Critical',
}

const BADGE_TONE: Record<string, 'success' | 'warning' | 'critical'> = {
  ready:           'success',
  needs_attention: 'warning',
  critical:        'critical',
}

type Props = {
  report: HealthReport
}

export function ReadinessScoreCard({ report }: Props) {
  const color = LEVEL_COLOR[report.readinessLevel]
  return (
    <Card>
      <BlockStack gap="200">
        <Text as="h2" variant="headingMd">Overall Data Readiness</Text>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0' }}>
          <div style={{
            fontSize: 48, fontWeight: 700, lineHeight: 1,
            color: color.text, background: color.bg,
            borderRadius: 12, padding: '8px 16px',
          }}>
            {report.overallScore}
          </div>
          <BlockStack gap="100">
            <Badge tone={BADGE_TONE[report.readinessLevel]}>{LEVEL_LABEL[report.readinessLevel]}</Badge>
            <Text as="p" variant="bodySm" tone="subdued">
              {report.totalCritical > 0
                ? `${report.totalCritical} critical · ${report.totalIssues - report.totalCritical} warnings`
                : report.totalIssues > 0
                ? `${report.totalIssues} issues to address`
                : 'No issues found'}
            </Text>
          </BlockStack>
        </div>
        <Text as="p" variant="bodySm" tone="subdued">
          Last scanned {new Date(report.generatedAt).toLocaleString()}
        </Text>
      </BlockStack>
    </Card>
  )
}
